import { render, staticRenderFns } from "./DRSTAddressMatrixInputBox.vue?vue&type=template&id=0cc4ef47&"
import script from "./DRSTAddressMatrixInputBox.vue?vue&type=script&lang=ts&"
export * from "./DRSTAddressMatrixInputBox.vue?vue&type=script&lang=ts&"
import style0 from "./DRSTAddressMatrixInputBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc4ef47')) {
      api.createRecord('0cc4ef47', component.options)
    } else {
      api.reload('0cc4ef47', component.options)
    }
    module.hot.accept("./DRSTAddressMatrixInputBox.vue?vue&type=template&id=0cc4ef47&", function () {
      api.rerender('0cc4ef47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/inputs/DRSTAddressMatrixInputBox.vue"
export default component.exports